import React from "react"
import { Helmet } from "react-helmet"

function SEO({ title }) {
    const description = "Description";

    return (
        <Helmet
            htmlAttributes={{ lang: 'en' }}
            title={title}
            meta={[
                {
                    name: `description`,
                    content: description
                },
                {
                    property: `og:title`,
                    content: "Emanuel Zevallos | Leading Emotion Code, Body Code Practitioner"
                },
                {
                    property: `og:description`,
                    content: description
                },
                {
                    property: `og:type`,
                    content: `website`
                }
            ]}
        />
    )
}

export default SEO
